import { FC } from 'react';
import { NavLink, Link } from 'react-router-dom';

const Navbar: FC = () => {
  return (
    <nav className="navbar">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/images/dldv.svg" alt="DLDV Enterprises" className="h-10" />
            </Link>
          </div>
          
          <div className="hidden md:flex space-x-8">
            <NavLink to="/" className={({ isActive }) => isActive ? "active-nav-link" : "nav-link"}>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => isActive ? "active-nav-link" : "nav-link"}>
              About
            </NavLink>
            <NavLink to="/services" className={({ isActive }) => isActive ? "active-nav-link" : "nav-link"}>
              Services
            </NavLink>
            <NavLink to="/ai-automation" className={({ isActive }) => isActive ? "active-nav-link" : "nav-link"}>
              AI & Automation
            </NavLink>
            <a href="https://calendly.com/dirk-de-vlaam/meeting-with-dirk-de-vlaam-from-dldv-enterprises" target="_blank" rel="noopener noreferrer" className="nav-link">
              Contact
            </a>
          </div>
          
          <div className="md:hidden">
            <button className="mobile-menu-button">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile menu - hidden by default */}
      <div className="md:hidden hidden mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <NavLink to="/" className={({ isActive }) => 
            isActive ? "block px-3 py-2 rounded-md text-base font-medium bg-accent-color text-white" : 
            "block px-3 py-2 rounded-md text-base font-medium text-primary-color hover:bg-gray-100"
          }>
            Home
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => 
            isActive ? "block px-3 py-2 rounded-md text-base font-medium bg-accent-color text-white" : 
            "block px-3 py-2 rounded-md text-base font-medium text-primary-color hover:bg-gray-100"
          }>
            About
          </NavLink>
          <NavLink to="/services" className={({ isActive }) => 
            isActive ? "block px-3 py-2 rounded-md text-base font-medium bg-accent-color text-white" : 
            "block px-3 py-2 rounded-md text-base font-medium text-primary-color hover:bg-gray-100"
          }>
            Services
          </NavLink>
          <NavLink to="/ai-automation" className={({ isActive }) => 
            isActive ? "block px-3 py-2 rounded-md text-base font-medium bg-accent-color text-white" : 
            "block px-3 py-2 rounded-md text-base font-medium text-primary-color hover:bg-gray-100"
          }>
            AI & Automation
          </NavLink>
          <a href="https://calendly.com/dirk-de-vlaam/meeting-with-dirk-de-vlaam-from-dldv-enterprises" target="_blank" rel="noopener noreferrer" className="block px-3 py-2 rounded-md text-base font-medium text-primary-color hover:bg-gray-100">
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
